/**
 * All the utility functions goes here
 * @author Sandeep G
 * @since 20201206
 */
import React from "react";
import ReactDOM from "react-dom";

import ComponentSpinner from "./../components/@vuexy/spinner/Loading-spinner";
import { getDecryptedItem } from "./encryptedStorage";

/**
 * resonsible for showing the loader
 */
function showLoader(statusBit) {
  ReactDOM.render(
    <ComponentSpinner show={statusBit} />,
    document.getElementById("custom-loader")
  );
}

/**
 * responsible for checking the validity of the mail
 * @param {} email
 */
const isValidEmail = (email) => {
  if (!email) return false;

  //match the regex
  const pattern =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!pattern.test(String(email).toLowerCase())) {
    return false;
  }

  return true;
};

/**
 * responsible for checking the validity of the dates
 * 1. dates are valid
 * 2. start date is smaller than end date
 */
const validateStartEndDate = (start, end) => {
  //validate the date type
  if (new Date(start) > new Date(end) || new Date(end) < new Date(start)) {
    return false;
  }

  return true;
};
/**
 * responsible for checking the validity of contact number
 */
const validateContactNumber = (contactNumber) => {
  if (contactNumber.length !== 11) {
    return false;
  }
  return true;
};

const removeDuplicatesFromAnArray = (inputArray) =>
  inputArray.filter((element, index) => inputArray.indexOf(element) === index);

const getMaskedEmail = (email) => {
  if (email) {
    let split = email.split("@");
    return (
      email.substr(0, 1) +
      "..." +
      split[0].substr(split[0].length - 1) +
      "@" +
      split[1]
    );
  }
  return email;
};

const removeAllSpaces = (str) => (str ? str.replace(/\s/g, "") : str);

const sortAscending = (arr, key) => {
  if (arr?.length) {
    if (key) {
      return arr.slice().sort((a, b) => {
        if (a[key] < b[key]) {
          return -1;
        }
        if (a[key] > b[key]) {
          return 1;
        }
        return 0;
      });
    }
    return arr.slice().sort((a, b) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });
  }
  return arr;
};

const getCustomConfig = () => {
  const isSuperAdminLoggedIn =
    getDecryptedItem("isSuperAdminLoggedIn") === "true";
  const config = {
    headers: {},
  };

  if (isSuperAdminLoggedIn) {
    config.headers.user_org = "SYSTEM_ADMIN";
  }

  return config;
};

const convertTimestampToBrowserDate = (timestampInMilliseconds, format) => {
  if (timestampInMilliseconds) {
    const date = new Date(timestampInMilliseconds);

    let day = date.getDate();
    let month = date.getMonth() + 1;
    const year = date.getFullYear();

    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }

    switch (String(format).toLowerCase()) {
      case "dd-mm-yyyy":
        return `${day}-${month}-${year}`;
      case "yyyy-mm-dd":
        return `${year}-${month}-${day}`;
      default:
        return `${day}-${month}-${year}`;
    }
  }

  return "";
};

const convertBrowserDateToTimestamp = (dateString, format) => {
  if (!dateString) return null;

  let day, month, year;

  switch (String(format).toLowerCase()) {
    case "dd-mm-yyyy": {
      [day, month, year] = dateString.split("-");
      break;
    }
    case "yyyy-mm-dd": {
      [year, month, day] = dateString.split("-");
      break;
    }
    default: {
      [day, month, year] = dateString.split("-");
    }
  }

  const d = parseInt(day, 10);
  const m = parseInt(month, 10) - 1;
  const y = parseInt(year, 10);

  const dateObj = new Date(y, m, d);

  if (isNaN(dateObj.getTime())) {
    return null;
  }

  return dateObj.getTime();
};

const formatDateToDateTimeLocal = (timestampInMilliseconds) => {
  if (!timestampInMilliseconds) return "";

  const date = new Date(timestampInMilliseconds);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

function maskApiKey(apiKey) {
  if (!apiKey || apiKey.length < 4) return apiKey;

  const start = apiKey.slice(0, 2);
  const end = apiKey.slice(-2);
  const masked = "*".repeat(apiKey.length - 4);

  return `${start}${masked}${end}`;
}

const isValidString = (str) => {
  return /^[A-Za-z][A-Za-z0-9_\- ]*$/.test(str);
};


const RESERVED_KEYWORDS = new Set([
  "false",
  "await",
  "else",
  "import",
  "pass",
  "none",
  "break",
  "except",
  "in",
  "raise",
  "true",
  "class",
  "finally",
  "is",
  "return",
  "and",
  "continue",
  "for",
  "lambda",
  "try",
  "as",
  "def",
  "from",
  "nonlocal",
  "while",
  "assert",
  "del",
  "global",
  "not",
  "with",
  "async",
  "elif",
  "if",
  "or",
  "yield",
  "bool",
  "dict",
  "float",
  "int",
  "isinstance",
  "len",
  "list",
  "open",
  "print",
  "set",
  "str",
  "table",
  "field",
  "optional",
  "union",
  "any",
]);

const isReservedKeyword = (str) => RESERVED_KEYWORDS.has(str.toLowerCase());

const isValidFormat = (str) =>
  /^[a-zA-Z][a-zA-Z0-9_]*(?:_[a-zA-Z0-9_]+)*$/.test(str);

export {
  isValidEmail,
  validateStartEndDate,
  validateContactNumber,
  showLoader,
  removeDuplicatesFromAnArray,
  getMaskedEmail,
  removeAllSpaces,
  sortAscending,
  getCustomConfig,
  convertTimestampToBrowserDate,
  maskApiKey,
  isValidString,
  isValidFormat,
  isReservedKeyword,
  convertBrowserDateToTimestamp,
  formatDateToDateTimeLocal,
};
